module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro#toc_marker-2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#toc_marker-3"
    }
  }, [_vm._v("1 Called to Be Saints")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_c('i', [_vm._v("The Need for a Compelling Theology of Holiness")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#toc_marker-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Union with Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Essence of the Christian Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#toc_marker-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Holy People Are Wise People")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Invitation to Sapiential Holiness")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#toc_marker-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Called to Do Good Work")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Invitation to Vocational Holiness")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Learning to Love")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Invitation to Social Holiness")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Joy and the Ordering of the Affections")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Invitation to Emotional Holiness")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixA#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Congregations and Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixA",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Church and the Call to Spiritual Maturity")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixB#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Christian Higher Education")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixB",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Passion for Wisdom and Spiritual Transformation")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/nameindex#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Name Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/subjectindex#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/aboutauthor#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0